<template>
      <v-card hover flat>
        <v-form ref="form" v-model="valid" lazy-validation enctype="multipart/form-data">

            <v-card-title>
            <h2 class="headline mb-0"><span style="color: #0D47A0">{{ this.datos.id ? 'Factura: #' + this.datos.id : '' }} Monto solicitud: {{ Number(this.datos.amount ? this.datos.amount : '').toLocaleString('es-VE', {style:'currency', currency:'BSS'}) }}</span></h2>
          </v-card-title>
          <v-card-title>
            <h3 class="headline mb-0"><span style="color: #0D47A0">{{ this.datos.razon_social ? (this.datos.razon_social).toUpperCase() : '' }} </span></h3>
          </v-card-title>

          <v-card-text>

                <v-flex xs12 align-center justify-space-between>
                    <v-layout align-center>

                        <v-flex xs12 md4>
                            <v-text-field
                                readonly
                                prepend-icon="featured_video"
                                v-model="form.rif"
                                label="Rif"
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs12 md8>
                            <v-text-field
                                readonly
                                prepend-icon="person"
                                v-model="form.razon_social"
                                label="Cliente"
                            ></v-text-field>
                        </v-flex>

                    </v-layout>
                </v-flex>

                <v-flex xs12 align-center justify-space-between>
                    <v-layout align-center>
                        <v-flex xs12 md4>
                            <v-text-field
                                readonly
                                prepend-icon="account_balance_wallet"
                                v-model="form.amount"
                                label="Monto"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-text-field
                                readonly
                                prepend-icon="settings_backup_restore"
                                v-model="form.status"
                                label="Estatus"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-flex>

                <v-flex xs12 sm6 v-show="form.status == 'PENDIENTE'">
                    <v-menu
                        ref="menu"
                        lazy
                        :close-on-content-click="false"
                        v-model="menu"
                        transition="scale-transition"
                        offset-y
                        full-width
                        :nudge-right="40"
                        min-width="290px"
                        :return-value.sync="date"
                    >
                        <v-text-field
                            slot="activator"
                            label="Fecha Conciliación"
                            v-model="computedDateFormattedFecha"
                            hint="DD/MM/YYYY formato"
                            prepend-icon="event"
                            :rules="[v => !!v || 'Fecha Conciliación es requerido']"
                        ></v-text-field>
                        <v-date-picker color="primary" :max="new Date().toISOString().slice(0,10)" v-model="form.payment_date2" no-title scrollable>
                        <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                            <v-btn flat color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                        </v-date-picker>
                    </v-menu>
            </v-flex>

                <v-expansion-panel>
                    <v-expansion-panel-content v-for="(pay, key) in form.payments" :key="pay.id">
                        <template v-slot:actions>
                            <v-icon color="primary">{{ form.payments[key].agreement ? 'done' : 'error' }}</v-icon>
                        </template>
                        <template v-slot:header>
                            <div>Pago {{ (key + 1) }}</div>
                        </template>
                        <v-card>
                            <v-card-text class="grey lighten-3">

                                <v-alert :value="pay.existepay.length != 0" type="error">
                                    <ul>
                                        <li v-for="pago in pay.existepay" :key="pago.id">
                                            <strong>IMPORTANTE! Existe un mismo pago APROBADO {{ pay.invoice_id == pago.invoice_id ? 'para esta factura:' : 'para otra factura:' }} {{ pago.invoice_id }} en el banco: {{ pago.bank.name }} por un monto: BsS {{ new Intl.NumberFormat("de-DE").format(parseFloat(pago.amount).toFixedDown(2)) }}</strong>
                                        </li>
                                    </ul>
                                </v-alert>

                                <v-text-field
                                    v-if="form.payments[key].way_to_pay == 'PUNTO ELECTRONICO' || form.payments[key].way_to_pay == 'TRANSFERENCIA'"
                                    readonly
                                    prepend-icon="account_balance"
                                    v-model="form.payments[key].bank.name"
                                    label="Banco"
                                ></v-text-field>

                                <v-flex xs12 align-center justify-space-between>
                                    <v-layout align-center>

                                        <v-flex xs12 md4>
                                            <v-text-field
                                                readonly
                                                prepend-icon="payment"
                                                v-model="form.payments[key].way_to_pay"
                                                label="Metodo de Pago"
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 md4>
                                            <v-text-field
                                                readonly
                                                prepend-icon="drag_handle"
                                                v-model="form.payments[key].number"
                                                label="Numero Transaccion"
                                            ></v-text-field>
                                        </v-flex>

                                         <v-flex xs12 md4>
                                            <v-text-field
                                                readonly
                                                prepend-icon="event"
                                                v-model="form.payments[key].payment_date"
                                                label="Fecha Transacción"
                                            ></v-text-field>
                                        </v-flex>

                                    </v-layout>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field
                                        prepend-icon="account_balance_wallet"
                                        v-model="form.payments[key].amount"
                                        label="Ingrese Monto Pagado"
                                    ></v-text-field>
                                </v-flex>

                                <v-text-field
                                    prepend-icon="insert_comment"
                                    v-model="form.payments[key].observations"
                                    label="Observaciones"
                                ></v-text-field>

                                <v-flex xs12 align-center justify-center layout text-xs-center>
                                    <v-btn color="primary" :href="`/storage/documents/pagos/${form.payments[key].src}`" target="_blank">
                                        VER DOCUMENTO
                                    </v-btn>
                                </v-flex>
                            </v-card-text>
                            <v-card-actions class="grey lighten-3" v-if="!form.payments[key].agreement">
                                <v-btn :loading="loading" class="error" @click="rechazarPago(pay,key)">Rechazar Pago</v-btn>
                                <v-spacer></v-spacer>
                                <v-btn :loading="loading" class="error" @click="eliminarPago(pay,key)"><v-icon>delete</v-icon></v-btn>
                                <v-spacer></v-spacer>
                                <v-btn :loading="loading" class="success" @click="aprobarPago(pay,key)">Confirmar Pago</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-expansion-panel-content>
                </v-expansion-panel>

          </v-card-text>

          <v-card-actions>
            <v-btn @click="cerrarDialog(null)">Cerrar</v-btn>
            <v-spacer></v-spacer>
            <!-- <v-btn :disabled="loading" class="error" @click="anulacionDialog">Anular Factura</v-btn>
            <v-btn :disabled="loading" class="success" @click="changeStatusConciliacion('PAGADO')">Aprobar Factura</v-btn> -->
          </v-card-actions>

        </v-form>
        <!-- dialog para anular invoice -->
        <v-dialog v-model="dialogAnulacion" width="500" persistent>
            <v-card hover flat>
                <v-form ref="formanular" v-model="valid" lazy-validation enctype="multipart/form-data">
                    <v-card-text>
                        <p>Describa el motivo de invalidación en la factura número <strong>{{form.id}}:</strong></p>
                        <v-textarea
                            v-model="formAnulacion.motivo_anulacion"
                            prepend-icon="insert_comment"
                            auto-grow
                            box
                            color="primary"
                            label="Motivo de anulacion"
                            rows="2"
                            required
                            :rules="[v => !!v || 'El motivo de anulación es requerido']"
                        ></v-textarea>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn @click="cerrarDialogAnular">Cerrar</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn :loading="loading" class="primary" @click="aprobAnulacion">Anular</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <!-- fin dialog para anular invoice -->
      </v-card>
</template>

<script>
import axios from 'axios'
import Form from 'vform'


Number.prototype.toFixedDown = function(digits) {
    var re = new RegExp("(\\d+\\.\\d{" + digits + "})(\\d)"),
        m = this.toString().match(re);
    return m ? parseFloat(m[1]) : this.valueOf();
};

export default {
    
    name: 'form-invoice-status-view',

    props: {
        loading: {
            type: Boolean,
            required: true
        },
        datos: {
            type: Object,
            required: true
        },
        iscuentascobrar: {
            type: Boolean,
            default: false
        }
    },

    watch: {
        datos(v) {
            this.$refs.form.resetValidation()
            
            v.payments.forEach(function(value, index) {
                v.payments[index].existepay = []
                v.payments_unionize.forEach(pu => {
                    if(value.number == pu.number && value.bank_id == pu.bank_id && pu.agreement && value.id != pu.id){
                        v.payments[index].existepay.push(pu)
                    }
                })
            })

            this.form = {
                id: v.id,
                rif: v.rif,
                unionize_cpc: v.unionize.cpc,
                direccion_fiscal: v.direccion_fiscal,
                razon_social: v.razon_social,
                status: v.status,
                payments: v.payments,
                amount: v.amount,
                payment_date2: new Date().toISOString().slice(0,10)
            }
        }
    },

    computed: {
        computedDateFormattedFecha () {
            return this.formatDate(this.form.payment_date2)
        }
    },


  data: () => ({
    valid: false,
    dialogAnulacion: false,
    status: ['PAGADO','PENDIENTE','ANULADO'],
    formAnulacion: new Form({
        motivo_anulacion: '',
    }),
    date: null,
    fecha: null,
    menu: false,
    form: new Form({
        id: '',
        pay_id: '',
        payments: [],
        rif: '',
        bank_id: '',
        unionize_cpc: '',
        direccion_fiscal: '',
        razon_social: '',
        way_to_pay: '',
        status: '',
        number: '',
        payment_date: '',
        payment_date2: '',
        observations: '',
        src: '',
        amount: ''
    })
  }),

  mounted() {
    this.$store.dispatch('clearMessage')
  },

  methods: {

    formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
    },
    
    async rechazarPago (pago,indice) {
        if(pago.observations == null || pago.observations == '') {
            this.$store.dispatch('responseMessage', {
                type: 'info',
                text: `Ingrese la observacion del pago`
            })
        } else {
            this.$emit('responseLoading', true)
            this.form.payments[indice].amount = 0
            let url = '/api/administration/cobranza/rechazar-pago'
            // if(this.iscuentascobrar){
            //     url = '/api/administration/cobranza/rechazar-pago-cuenta-cobrar'
            // }
            await axios.post(url, pago).then(resp => {
                this.form.payments[indice].agreement = resp.data.agreement
                this.form.payments[indice].agreement = resp.data.agreement
                this.$store.dispatch('responseMessage', {
                    type: 'error',
                    text: `Pago rechazado`
                })
                this.cerrarDialog(resp)
            }).catch(error => {
                console.log(error.response)
            }).finally(() => this.$emit('responseLoading', false))
        }
    },

    async eliminarPago (pago) {
        this.$emit('responseLoading', true)
        let confirmDelete = confirm('Seguro que desea eliminar el registro del pago?')
          if (confirmDelete) {
            await axios.delete('/api/payments/admin/' + pago.id)
            .then(response => {
                this.$store.dispatch('responseMessage', {
                    type: 'error',
                    text: `Pago eliminado`
                })
                this.cerrarDialog(response)
            }).catch(error => {
                console.log(error.response)
            }).finally(() => this.$emit('responseLoading', false))
          }
    },
    
    async aprobarPago (pago,indice) {
        pago.payment_date2 = this.form.payment_date2
        if(this.form.payments[indice].amount == 0){
            this.$store.dispatch('responseMessage', {
                type: 'info',
                text: `Ingrese el monto pagado`
            })
        }else if(this.form.payments[indice].observations == null || this.form.payments[indice].observations == '') {
            this.$store.dispatch('responseMessage', {
                type: 'info',
                text: `Ingrese la observacion del pago`
            })
        } else {
            this.$emit('responseLoading', true)
            let url = '/api/administration/cobranza/aprobar-pago'
            // if(this.iscuentascobrar){
            //     url = '/api/administration/cobranza/aprobar-pago-cuentas-cobrar'
            // }
            await axios.post(url, pago).then(resp => {
                this.form.payments[indice].agreement = resp.data.agreement
                this.cerrarDialog(resp.data)
                this.$store.dispatch('responseMessage', {
                    type: 'success',
                    text: `Pago aprobado`
                })
            }).catch(e => {
                console.log(e.response)
                if (e.response.data.errors) {
                    if (e.response.data.errors.security_paper) {
                        this.$store.dispatch('responseMessage', {
                            type: 'error',
                            text: e.response.data.errors.security_paper
                        })
                    }else {
                        this.$store.dispatch('responseMessage', {
                            type: 'error',
                            text: e.response.data.error
                        })
                    }
                }
            }).finally(() => this.$emit('responseLoading', false))
        }
    },

    changeInfo (data) {
        console.log(data)
    },

    cerrarDialog (data) {
        this.$emit('closeDialogInvoiceStatus', data)
        this.$nextTick(() => {
            this.$refs.form.resetValidation()
            this.$emit('responseLoading', false)
        })
    },

    cerrarDialogAnular () {
        this.dialogAnulacion = false
        this.$nextTick(() => {
            this.$refs.formanular.resetValidation()
            this.$emit('responseLoading', false)
        })
    },

    anulacionDialog () {
        this.dialogAnulacion = true
    },

    aprobAnulacion () {
        if (this.$refs.formanular.validate()) {
            this.changeStatusConciliacion('ANULADO')
        }
    },

    async changeStatusConciliacion (status) {
        this.$emit('responseLoading', true)
        await axios.post('/api/administration/cobranza/conciliacion-change-status',{ id: this.form.id, status: status, motivo_anulacion: this.formAnulacion.motivo_anulacion }).then((resp) => {
            console.log(resp,'resp')
            this.form.status = status
            this.$store.dispatch('responseMessage', {
                type: 'success',
                text: `Cambio de estatus a ${status} exitoso`
            })
            this.cerrarDialog(resp)
        }).catch((error) => {
            console.log(error.response)
            if(error.response){
                if(error.response.status == 404){
                    this.$store.dispatch('responseMessage', {
                        type: 'error',
                        text: 'No se encontro la factura, intente nuevamente.'
                    })   
                }else if(error.response.status == 403) {
                    this.$store.dispatch('responseMessage', {
                        type: 'error',
                        text: 'No es posible actualizar esta factura.'
                    })  
                }
            } else {
                console.log('Error', error.message);
            }
        }).finally(() => this.$emit('responseLoading', false))
    }

  }

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/cobranza/formInvoiceStatus.vue